import React, { useState, useEffect } from 'react';
import vehicleService from '../../services/vehicleService';
import communicationService, { COMM_EVENT_KEYS } from '../../services/communicationService';
import toast from 'react-hot-toast';

const INITIAL = {
  registration_number: '',
  make: '',
  model: '',
  year: '',
  capacity: '',
  sacco_name: 'Mololine',
  route: '',
  status: 'active',
  tlb_renewal_due_date: '',
  ntsa_inspection_due_date: '',
  speed_governor_renewal_due_date: '',
  insurance_expiry: '',
  purchase_price: '',
};

export default function VehicleForm({ vehicle, onSuccess, onCancel }) {
  const [form, setForm]   = useState(INITIAL);
  const [sendEmail, setSendEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const isEdit = Boolean(vehicle);

  useEffect(() => { if (vehicle) setForm({ ...INITIAL, ...vehicle }); }, [vehicle]);

  const handle = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const saved = isEdit
        ? await vehicleService.update(vehicle.id, form)
        : await vehicleService.create(form);

      if (sendEmail) {
        try {
          await communicationService.dispatchEvent(COMM_EVENT_KEYS.VEHICLE_REGISTERED, {
            vehicle_id: saved?.id || vehicle?.id,
            registration_number: form.registration_number,
            context: { action: isEdit ? 'vehicle_updated' : 'vehicle_registered' },
          });
        } catch {
          toast.error('Vehicle saved, but email dispatch is not configured');
        }
      }

      toast.success(isEdit ? 'Vehicle updated' : 'Vehicle registered');
      onSuccess();
    } catch (err) {
      const d = err.response?.data;
      if (d) Object.values(d).forEach(v => toast.error(Array.isArray(v) ? v[0] : v));
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit}>
      <div className="grid-2">
        <div className="form-group">
          <label className="form-label">Registration Number *</label>
          <input className="form-control" name="registration_number" value={form.registration_number} onChange={handle} placeholder="KBZ 123A" required style={{ textTransform: 'uppercase' }} />
        </div>
        <div className="form-group">
          <label className="form-label">Sacco Name</label>
          <input className="form-control" name="sacco_name" value={form.sacco_name} onChange={handle} />
        </div>
      </div>
      <div className="grid-3">
        <div className="form-group">
          <label className="form-label">Make *</label>
          <input className="form-control" name="make" value={form.make} onChange={handle} placeholder="Toyota" required />
        </div>
        <div className="form-group">
          <label className="form-label">Model *</label>
          <input className="form-control" name="model" value={form.model} onChange={handle} placeholder="HiAce" required />
        </div>
        <div className="form-group">
          <label className="form-label">Year</label>
          <input className="form-control" type="number" name="year" value={form.year} onChange={handle} placeholder="2020" min="1990" max="2030" />
        </div>
      </div>
      <div className="grid-2">
        <div className="form-group">
          <label className="form-label">Capacity (seats)</label>
          <input className="form-control" type="number" name="capacity" value={form.capacity} onChange={handle} placeholder="14" />
        </div>
        <div className="form-group">
          <label className="form-label">Route</label>
          <input className="form-control" name="route" value={form.route} onChange={handle} placeholder="CBD — Thika" />
        </div>
      </div>
      <div className="grid-2">
        <div className="form-group">
          <label className="form-label">TLB Renewal Due Date</label>
          <input className="form-control" type="date" name="tlb_renewal_due_date" value={form.tlb_renewal_due_date} onChange={handle} />
        </div>
        <div className="form-group">
          <label className="form-label">NTSA Annual Inspection Due Date</label>
          <input className="form-control" type="date" name="ntsa_inspection_due_date" value={form.ntsa_inspection_due_date} onChange={handle} />
        </div>
      </div>
      <div className="grid-2">
        <div className="form-group">
          <label className="form-label">Speed Governor Renewal Due Date</label>
          <input className="form-control" type="date" name="speed_governor_renewal_due_date" value={form.speed_governor_renewal_due_date} onChange={handle} />
        </div>
        <div className="form-group">
          <label className="form-label">Status</label>
          <select className="form-control" name="status" value={form.status} onChange={handle}>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="under_maintenance">Under Maintenance</option>
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Insurance Expiry</label>
          <input className="form-control" type="date" name="insurance_expiry" value={form.insurance_expiry} onChange={handle} />
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">Purchase Price (KES)</label>
        <input className="form-control" type="number" name="purchase_price" value={form.purchase_price} onChange={handle} placeholder="0" />
      </div>
      <div className="form-group">
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', color: 'var(--gray-600)' }}>
          <input
            type="checkbox"
            checked={sendEmail}
            onChange={(e) => setSendEmail(e.target.checked)}
          />
          Send vehicle update email
        </label>
      </div>
      <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '0.5rem' }}>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving…' : isEdit ? 'Update Vehicle' : 'Register Vehicle'}
        </button>
      </div>
    </form>
  );
}